import { BasicSignupStepProps } from 'containers/SignUp/Content/content.types';
import RadioGroup from 'shared/RadioGroup';

import { useGetSelectedItem } from 'hooks/useGetSelectedItem';
import useSubmitOrchestrateForm from 'hooks/useSubmitOrchestrateForm';
import { FlowTypes } from 'utils/enums';

import Heading from '../../components/Heading';

const REGULAR_OPTIONS = [
  { label: 'Ozempic', value: 'ozempic' },
  { label: 'Wegovy', value: 'wegovy' },
  { label: 'Zepbound', value: 'zepbound' },
  { label: 'Mounjaro', value: 'mounjaro' },
  { label: 'Non-insurance options (semaglutide)', value: 'other' },
  { label: 'Discuss with my provider', value: 'discuss' }
];

const BLUE_LINE_OPTIONS = [
  { label: 'Ozempic', value: 'ozempic' },
  { label: 'Wegovy', value: 'wegovy' },
  { label: 'Mounjaro', value: 'mounjaro' },
  { label: 'Zepbound', value: 'zepbound' },
  { label: 'Discuss with my provider', value: 'discuss' }
];

const PreferredMedication: React.FC<BasicSignupStepProps> = ({ selectedFlow, moveToStep }) => {
  const { send, isLoading } = useSubmitOrchestrateForm();
  const { value, setValue } = useGetSelectedItem('preferred_medication');

  const handleSelect = (answer: string, cb?: () => void) => {
    setValue(answer);
    send('mif_qa', [{ answer, question: 'preferred_medication' }], () => {
      moveToStep('next');
      cb?.();
    });
  };

  const options = selectedFlow === FlowTypes.BlueLineFlow ? BLUE_LINE_OPTIONS : REGULAR_OPTIONS;

  return (
    <div className="flex flex-col gap-6">
      <Heading
        category="Plan"
        subtitle="Your provider will review your selection along with your medical profile."
        title="Choose your preferred medication."
      />
      <RadioGroup
        isLoading={isLoading}
        items={options}
        selectedItem={value as string}
        onSelect={handleSelect}
      />
    </div>
  );
};

export default PreferredMedication;
